import React, {Fragment} from "react";
import HookSubFormEAL from "root/Base/HookFormComponents/SEND/HookSubFormEAL";
import HookSubFormPupilPremium from "root/Base/HookFormComponents/SEND/HookSubFormPupilPremium";
import HookSubFormSEND from "root/Base/HookFormComponents/SEND/HookSubFormSEND";
import HookSubFormStatutoryReferral from "root/Base/HookFormComponents/SEND/HookSubFormStatutoryReferral";
import HookSubFormStarFunding from "root/Base/HookFormComponents/Education/HookSubFormStarFunding";

const HookFormGroupSend = ({control, register, watch, formErrors, readOnly, isPost16 }) =>
{
    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
        readOnly: readOnly
    }

    const showPP = !isPost16 ; // ( [12,13].includes(+year_id) === false )  ;

    return (
        <Fragment>
            <HookSubFormEAL { ...controlProps } sectionName='eal'/>
            { showPP === true && <HookSubFormPupilPremium { ...controlProps } sectionName='pp_plus'/> }
            <HookSubFormSEND { ...controlProps } sectionName='sen' isPost16={isPost16}/>
            <HookSubFormStatutoryReferral { ...controlProps } sectionName='statutory'/>
            { isPost16 === false && <HookSubFormStarFunding { ...controlProps } sectionName='star_funding'/> }
        </Fragment>
    )
    }

export default HookFormGroupSend ;